<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="email-send">
    <div class="email-wrap">
      <div class="email-head">
        <div class="icon-ajuntament" />
      </div>
      <h2>{{ $t('email_send') }}</h2>
      <p class="email-desc">{{ $t('email_desc') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      emailInput: '',
    }
  },
  computed: {},
  watch: {},
  methods: {
  },
}
</script>

<style lang="stylus" scoped>
.email-send
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  min-height: 80vh
  background-color: rgba($bcn-dark-blue-gray, 0.05)

  .email-wrap
    display: flex
    flex-direction: column
    align-items: center
    padding: vw(20px)
    min-width: 250px
    width: 60%
    border-radius: 8px
    background-color: #fff
    box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)
    gap: vw(5px)

    .email-head
      display: flex
      justify-content: space-between
      width: 100%

      .icon-ajuntament
        width: vw(176px)
        height: vw(45px)
        background-image: url("~@/assets/logos/logo-ajuntament-barcelona-rounded.svg")
        background-position: center center
        background-size: cover
        background-repeat: no-repeat

    h2
      margin-block-start: 1.5em
      font-size(32, 44)
      font-weight: 600

    .email-desc
      display: flex
      justify-content: center
      font-size(20, 24)
      margin-bottom: vw(20px)
      width: 85%
      font-weight: 400
</style>